import { Component, OnDestroy, OnInit } from '@angular/core';
import { constants } from '../constants';
import { CommonUtilitiesService } from '../common-utilities.service';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RechargeService } from "./recharge.service";
import { DomSanitizer } from '@angular/platform-browser';

//jquery var
declare var $: any;

@Component({
  selector: 'app-recharge',
  templateUrl: './recharge.component.html',
  styleUrls: ['./recharge.component.scss']
})
export class RechargeComponent implements OnInit, OnDestroy {
  public RECARGAS: string = constants.FROM_RELOAD_PAGE;
  public CARE_CHANNELS_TITLE: string = this.LANG.getLangText("CARE_CHANNELS_FOOTER_TITTLE_GENERIC");

  //variables del wizard
  activeTab = 1;
  isNextStepReady = false;
  isBackDisabled = true;
  isStep1Checked = false;
  isStep2Checked = false;

  ///variables de modal
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isModalReload = false;

  //form
  rechargeForm: FormGroup;
  labelBtnEnd = this.LANG.getLangText('PORTABILITY_LABEL_CONTINUE');
  isLoggedLines = false;
  inOutSelected = 2;
  numericPattern = "";
  selectedAmouunt = 0;
  inputLine = null;
  selectedCard = null;
  isNewCard = false;
  isSaveCCard = false;
  isPayFrameShow = false;
  listLines = [];
  isLoadingBtn = false;
  allowedValues = [];
  allowedValuesUpper = [];
  allowedValuesLower = [];
  cardList = [];
  isLoadingDeleteBtn = false;
  isHideBtn = false;
  isPaymentFormLoading = false;

  //variables de la pasarela de pagos
  paymentFormInputList = [];
  urlFormPayment = "";
  idTransaction = null;
  onResponseTecnocom: any;


  constructor(public LANG: CommonUtilitiesService, private _router: Router, private formbuilder: FormBuilder, private rechargeService: RechargeService, private _sanitizer: DomSanitizer) { }


  ngOnInit() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.numericPattern = constants.REGEX_NUMERIC_PATTERN;
    this.rechargeForm = this.formbuilder.group({
      inputAlternativeLine: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputAmount: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputLines: ['', [Validators.required]],
    });

    //obtener datos valores de recargas
    this.getAllowedValues();

    //valida si esta loguado para msotrar las lineas
    this.isLoggedLines = false;
    if (this.LANG.isLogged()) {
      this.isLoggedLines = true;
      this.changeCheckClass(1);

      //obtiene las lineas de sesion
      let userData = JSON.parse(localStorage.getItem("userData"));
      for (var k in userData.associatedCellPhones) {
        this.listLines.push({ "id": userData.associatedCellPhones[k].id, "linea": userData.associatedCellPhones[k].id });
      }

      this.getStoredCards(userData.documentId);

    }
    this.addEventListenerToTecnocom();
  }
  ngOnDestroy() {
    window.removeEventListener('message', this.onResponseTecnocom);
  }

  /**
   * Description: Método que escucha mensajes post desde el iframe de DCP
   */
  addEventListenerToTecnocom() {
    this.onResponseTecnocom = (e) => {
      // Método para evaluar si requiere o no el cancel
      if (this.idTransaction) {
        if (typeof e.data == "string") {
          if (e.data.indexOf("STATUS=01") > -1) {
            this.rechargeService.startCancelAsync(this.idTransaction).subscribe(resp => {
              console.log("Cancel Async", resp);
            });
          }
        }
      }
    };
    window.addEventListener('message', this.onResponseTecnocom);
  }


  /**
   * Description: Método que obtiene los valores de recargas
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  getAllowedValues() {
    //obtiene valores permitidos de recargas
    this.isLoadingBtn = true;
    this.rechargeService.getAllowedRechargeValues().subscribe((valData => {
      this.isLoadingBtn = false;

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      }

      this.allowedValues = valData["obj"];
      let counter = 0;
      for (var k in this.allowedValues) {
        if (counter <= 4) {
          this.allowedValuesUpper.push(this.allowedValues[k]);
          counter++;
        } else {
          this.allowedValuesLower.push(this.allowedValues[k]);
        }
      }

    }),
      (err) => {
        this.isLoadingBtn = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });
  }

  /**
   * Description: Método que obtiene los datos de las tarjetas guardadas
   * Autor: Diego Diaz
   * @param documentId documento de identificación
   * @return N/A
   */
  getStoredCards(documentId) {
    //obtiene valores permitidos de recargas
    this.rechargeService.getStoredCards(documentId).subscribe((valData => {

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.cardList = [];
        return;
      }

      this.cardList = valData["obj"];

      if (this.cardList.length <= 0) {
        this.isNewCard = true;
      }

    }),
      (err) => {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });

  }

  /**
 * Description: Método que cambia la pantalla para continuar con el proceso de portabilidad
 * Autor: Diego Diaz
 * @param N/A
 * @return N/A
 */
  nextStep() {

    if (this.activeTab == 1) {

      if ((this.inOutSelected == 2 && this.rechargeForm.get('inputAlternativeLine').invalid) ||
        (this.inOutSelected == 1 && this.rechargeForm.get('inputLines').invalid)) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
        this.isShowModal = true;
        return;
      }

      if (this.selectedAmouunt == 0 || this.selectedAmouunt == null) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('RECHARGE_AMOUNT_ERROR');
        this.isShowModal = true;
        return;
      }

      //linea a mostrar
      if (this.inOutSelected == 2) {
        this.inputLine = this.rechargeForm.get('inputAlternativeLine').value;
      } else {
        this.inputLine = this.rechargeForm.get('inputLines').value
      }

      if (!this.LANG.isValidPhoneZero(this.inputLine)) {
        //si no tiene el prefijo 0 no puede seguir
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PHONE_VALIDATOR_ERROR_ZERO');
        this.isShowModal = true;
        return false;
      }

      //obtiene valores permitidos de recargas
      this.isLoadingBtn = true;
      this.rechargeService.validatePhoneInBrand(this.inputLine).subscribe((valData => {
        this.isLoadingBtn = false;
        if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE || valData['obj'].valid != true) {
          this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
          this.modalContent = this.LANG.getLangText('COMBOS_LABEL_MODAL_ERROR_LINE_NOT_IN_BRAND');
          this.isShowModal = true;
          return;
        }

        //seleeciona como activa la pestaña 2
        this.activeTab = 2;
        //cambia a la pestaña 2
        this.changeTab(2);
        //habilita boton de regresar
        this.isBackDisabled = false;
        //muestra el icono check del paso 1
        this.isStep1Checked = true;

        //sin login llama directamente el iframe.
        this.isPayFrameShow = false;
        if (!this.LANG.isLogged()) {
          this.isPayFrameShow = true;
          this.getPaymentIframe();
          return;
        }

        if (this.cardList != null && this.cardList.length <= 0) {
          this.isPayFrameShow = true;
          this.getPaymentIframe();
          return;
        }

      }),
        (err) => {
          this.isLoadingBtn = false;
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
          this.isShowModal = true;
          return;
        });

    } else if (this.activeTab == 2) {

      if (this.selectedCard == null && !this.isNewCard && !this.isPayFrameShow) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('RECHARGE_MODAL_CONTENT_CARD_VALIDATION');
        this.isShowModal = true;
        return;
      }
      this.isPayFrameShow = true;
      this.getPaymentIframe();

    }

  }

  /**
   * Description: Método que cambia de tab o paso en el wizard
   * Autor: Diego Diaz
   * @param tab paso que se desea mostrar
   * @return N/A
   */
  changeTab(tab) {
    var aStep = document.getElementById('step' + tab + '-tab');
    (<any>aStep).href = "#step" + tab;
    aStep.click();
  }

  /**
  * Description: Método que cambia la pantalla para volver con el paso 1 o 2 del proceso de portabilidad
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  backStep() {
    this.selectedCard = null;
    this.isHideBtn = false;
    this.isStep1Checked = false;
    this.isPayFrameShow = false;
    if (this.activeTab <= 2) {
      this.isBackDisabled = true;
    }

    if (this.activeTab > 1) {
      this.changeTab((this.activeTab - 1));
      this.activeTab = (this.activeTab - 1);
      this.labelBtnEnd = this.LANG.getLangText('PORTABILITY_LABEL_CONTINUE');
    }
  }


  /**
   * Description: Método que ocualta el modal
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    }
  }

  /**
 * Description: Método que asigna la clase activa al checkbox
 * Autor: Diego Diaz
 * @param id identificador del check
 * @return N/A
 */
  changeCheckClass(id) {
    this.isLoggedLines = false;
    if (id == 1) {
      $("#inoutBtn1").addClass("active");
      $("#inoutBtn2").removeClass("active");
      $("#inoutRadios1").prop("checked", "checked");
      this.isLoggedLines = true;
    } else if (id == 2) {
      $("#inoutBtn2").addClass("active");
      $("#inoutBtn1").removeClass("active");
      $("#inoutRadios2").prop("checked", "checked");
    }
    this.setSelectedInOutRadio(id);
  }

  /**
  * Description: Método que asigna el valor de la opcion seleccionada
  * Autor: Diego Diaz
  * @param id id del tipo de telefono seleccionado
  * @return N/A
  */
  setSelectedInOutRadio(id) {
    this.inOutSelected = id;
  }

  /**
  * Description: Método que asigna el valor de la recarga
  * Autor: Diego Diaz
  * @param amount cantidad a recargar
  * @return N/A
  */
  selectRechargeAmount(amount) {
    this.selectedAmouunt = amount;

    //removemos el seleccionado anterior
    $(".prices-selector .btn").each(function () {
      $(this).removeClass("active");
    });

    $("#recharge-val-" + amount).addClass("active");

  }

  /**
   * Description: Método que asigna la tarjeta
   * Autor: Diego Diaz
   * @param id tarjeta seleccionada
   * @return N/A
   */
  selectCard(id) {
    this.selectedCard = id;
    //removemos el seleccionado anterior
    $(".card-crud .btn").each(function () {
      $(this).removeClass("active");
    });

    $("#ccard-" + id).addClass("active");
  }

  /**
 * Description: Método que asigna la tarjeta nueva
 * Autor: Diego Diaz
 * @param N/A
 * @return N/A
 */
  selectAsNewCard() {
    this.isNewCard = true;
    this.nextStep();
  }

  /**
 * Description: Método que indica si se guarda o no la tarjeta
 * Autor: Diego Diaz
 * @param N/A
 * @return N/A
 */
  saveCreditCard() {
    this.isSaveCCard = false;
    if ($('#saveCCard').is(":checked")) {
      this.isSaveCCard = true;
      if (this.isPayFrameShow) {
        this.getPaymentIframe();
      }
    } else {
      this.isSaveCCard = false;
      if (this.isPayFrameShow) {
        this.getPaymentIframe();
      }
    }
  }

  /**
   * Description: Método que elimina una tarjeta
   * Autor: Diego Diaz
   * @param id identificador de la tarjeta
   * @return N/A
   */
  deleteCard(id) {
    //obtiene valores permitidos de recargas
    this.isLoadingDeleteBtn = true;
    this.rechargeService.deleteStoredCards(id).subscribe((valData => {
      this.isLoadingDeleteBtn = false;

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('RECHARGE_CARD_REMOVE_ERROR');
        this.isShowModal = true;
        return;
      }

      let auxList = this.cardList;
      this.cardList = [];
      for (var k in auxList) {
        if (auxList[k].id != id) {
          this.cardList.push(auxList[k]);
        }
      }

    }),
      (err) => {
        this.isLoadingDeleteBtn = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });
  }

  /**
  * Description: Método que obtiene el formulario de pagos
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  getPaymentIframe() {

    let jsonData = {};
    this.isPaymentFormLoading = true;
    if (this.LANG.isLogged()) {
      let userData = JSON.parse(localStorage.getItem("userData"));
      jsonData = {
        "msisdn": this.inputLine,
        "identification": userData.documentId,
        "valueToRecharge": this.selectedAmouunt,
        "isStoreCard": this.isSaveCCard,
        "paymentParam": constants.PAYMENT_FORM_REST_RECHARGE,
        "email": userData.email,
      };

      if (this.selectedCard != null && this.selectedCard > 0) {
        jsonData["idCreditCardSaved"] = this.selectedCard;
      }

    } else {
      jsonData = {
        "msisdn": this.inputLine,
        "valueToRecharge": this.selectedAmouunt,
        "isStoreCard": false,
        "paymentParam": constants.PAYMENT_FORM_REST_RECHARGE
      };
    }

    this.rechargeService.getPaymentForm(jsonData).subscribe((valData => {

      if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      }

      this.isHideBtn = true;
      //datos de condiguracion estatica
      this.urlFormPayment = valData["obj"].urlForm;
      var result = [];
      for (var i in valData["obj"].formData) {
        if (i === "IDTABLA") {
          this.idTransaction = valData["obj"].formData[i];
        } else {
          result.push([i, valData["obj"].formData[i]]);
        }
      }
      this.paymentFormInputList = result;

      let _self = this;
      setTimeout(function () {
        $("#submit-payment-form").click();
        _self.isPaymentFormLoading = false;
      }, 1000);

    }),
      (err) => {
        this.isPaymentFormLoading = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        return;
      });

  }


  /**
  * Description: Método que formatea la imagen de la franquicia
  * Autor: Diego Diaz
  * @param imgData blob de la imagen
  * @return imagen formateada
  */
  formatImg(base64Img) {
    return constants.BASE64_INIT + base64Img;
  }

}
